<div class="personal-form">
  <div id="form-company-container"></div>
  <!-- <form [formGroup]="form">
    <div class="inputs-container">
      <mat-form-field appearance="outline">
        <mat-label>Nombre*</mat-label>
        <input formControlName="name" autocomplete="off" type="text" matInput>
        <mat-error>Campo requerido</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Apellido*</mat-label>
        <input formControlName="lastName" autocomplete="off" type="text" matInput>
        <mat-error>Campo requerido</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Correo electrónico empresarial*</mat-label>
        <input formControlName="email" autocomplete="off" type="text" matInput>
        <mat-error>Campo requerido</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Teléfono de contacto*</mat-label>
        <input formControlName="phone" autocomplete="off" type="text" matInput>
        <mat-error>Campo requerido</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Nombre de la empresa*</mat-label>
        <input formControlName="company" autocomplete="off" type="text" matInput>
        <mat-error>Campo requerido</mat-error>
      </mat-form-field>

      <mat-form-field *ngIf="isAnual" appearance="outline">
        <mat-label>Sector al que pertenece la empresa*</mat-label>
        <mat-select formControlName="sector">
          <mat-option [value]="10">Sector bancario</mat-option>
          <mat-option [value]="100">Sector agropecuario</mat-option>
        </mat-select>
        <mat-error>Campo requerido</mat-error>
      </mat-form-field>
      <div class="space" *ngIf="!isAnual && !isIntegration"></div>
      <div class="space" *ngIf="isIntegration"></div>
    </div>
    <p *ngIf="!isIntegration">¿Deseas agregar alguno de los siguientes complementos?:* </p>
    <div class="checks-container" *ngIf="!isIntegration">
      <div class="column">
        <mat-checkbox><p class="checktext"><span>Video acuerdo</span> - $3.00 MXN por transacción</p></mat-checkbox>
        <mat-checkbox><p class="checktext"><span>Foto INE</span> - $3.00 MXN por transacción</p></mat-checkbox>
        <mat-checkbox><p class="checktext"><span>SMS</span> - $3.00 MXN por transacción</p></mat-checkbox>
        <mat-checkbox><p class="checktext"><span>Constancia de conservación en USA</span> - $5.00 MXN por transacción</p></mat-checkbox>
        <mat-checkbox><p class="checktext"><span>Constancia de conservación en Etherium</span> - $7.00 MXN por transacción</p></mat-checkbox>
      </div>
      <div class="column">
        <mat-checkbox><p class="checktext"><span>Foto INE+Comparación de firma</span> - $10.00 MXN por transacción</p></mat-checkbox>
        <mat-checkbox><p class="checktext"><span>Foto INE+Comparación de firma+comparación de video firma vs foto INE</span> - $12.00 MXN por transacción</p></mat-checkbox>
        <mat-checkbox><p class="checktext"><span>Foto INE+Comparación de firma+comparación de video acuerdo vs foto INE</span> - $12.00 MXN por transacción</p></mat-checkbox>
        <mat-checkbox><p class="checktext"><span>Foto INE+Comparación de firma+comparación de video acuerdo vs foto INE+comparación de video firma vs foto INE</span> - $14.00 MXN por transacción</p></mat-checkbox>
      </div>
    </div>
    <p *ngIf="!isIntegration">¿Cuantas transacciones deseas adquirir con este complemento*</p>
    <mat-form-field *ngIf="!isIntegration" appearance="outline">
      <mat-label></mat-label>
			<mat-select formControlName="transactionsPerComplement">
				<mat-option [value]="10">10</mat-option>
				<mat-option [value]="100">100</mat-option>
			</mat-select>
			<mat-error>Campo requerido</mat-error>
    </mat-form-field>

    <div class="integration-fields" *ngIf="isIntegration">
      <mat-form-field appearance="outline">
        <mat-label>Selecciona el día y la hora en que deseas que te contactemos:*</mat-label>
        <input matInput [matDatepicker]="picker1">
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label></mat-label>
        <input autocomplete="off" type="text" matInput>
        <mat-error>Campo requerido</mat-error>
      </mat-form-field>

      <div class="space"></div>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Cuéntanos un poco más de tu proyecto</mat-label>
        <textarea matInput></textarea>
      </mat-form-field>
    </div>
  </form> -->
  <form [id]="idForm"></form>
</div>
